import {
    minimizedChatIconActions, WebChatMinimizedIcon
} from '../../supportTicket/supportWindow';

export class EventBankOpenedHandler {
    public handle(): void {
        minimizedChatIconActions(WebChatMinimizedIcon.HIDE);
        window.helpshiftWebChatState.hideChatIcon = true;
        // eslint-disable-next-line new-cap
        window.HelpshiftWidget('close');
    }
}
